import * as React from 'react';
import { useDispatch } from 'react-redux';

import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { useLinkButtonUrl } from './hooks';
import { trackPromoLinkClickAction } from '../../actions/analytics';
import { EPromoType } from '../../types/promos/promoType';
import { TThunkDispatch } from '../../types/redux/thunk';

interface IOffersLinkContainerProps {
  promoId: string;
  promoType: EPromoType;
  newbuildingIds: number[];
}

export const OffersLinkContainer = ({ promoId, promoType, newbuildingIds }: IOffersLinkContainerProps) => {
  const url = useLinkButtonUrl(promoType, newbuildingIds);

  const dispatch: TThunkDispatch = useDispatch();
  const deviceType = useDeviceType();

  /* istanbul ignore next */
  const buttonText = React.useMemo(() => {
    if (promoType === EPromoType.CianMortgage) {
      return 'Смотреть предложения от банков';
    }

    if (deviceType === 'phone') {
      return 'Смотреть объявления';
    }

    return 'Объявления';
  }, [deviceType]);

  const handleLinkClick = React.useCallback(() => {
    dispatch(trackPromoLinkClickAction(promoId, 'to_offers'));
  }, [dispatch, promoId]);

  return (
    <LinkButton
      theme="fill_secondary"
      size="M"
      href={url}
      data-testid="OffersLink"
      onClick={handleLinkClick}
      target="_blank"
    >
      {buttonText}
    </LinkButton>
  );
};
